import React from "react";
// import Plot from 'react-plotly.js';
import { PlotlyPlot as Plot } from './PlotlyPlot.js';
import { leftBracket, rightBracket } from '../formatting.js';
function lBracket(bin) {
    return leftBracket(bin.leftClosed);
}
function rBracket(bin) {
    return rightBracket(bin.rightClosed);
}
export const hovertemplateSpec = {
    bin: "Třída #%{customdata[0]}: %{customdata[1]}%{customdata[2]:.2f} ; %{customdata[3]:.2f}%{customdata[4]}",
    centre: "Střed: %{x:.2f}",
    absfreq: "Abs. četnost: f<sub>%{customdata[0]}</sub> = %{y:.0}",
    relfreqperunit: "Rel. četnost na jednotku: f<sub>%{customdata[0]}</sub> = %{y:.0}",
    emptyextra: "<extra></extra>",
};
export function buildHovertemplate(keys, spec) {
    return keys.map(key => spec[key]).join("<br>");
}
export const defaultTraceSpec = {
    x: (bins) => bins.map(b => b.centre),
    y: (bins) => bins.map(b => b.frequency),
    text: (bins) => bins.map(b => b.frequency.toString()),
    customdata: (bins) => bins.map((b, index) => [
        index + 1,
        lBracket(b),
        b.left,
        b.right,
        rBracket(b), // customdata[4]: right bracked symbol
    ]),
    hovertemplate: buildHovertemplate(["bin", "centre", "absfreq", "emptyextra"], hovertemplateSpec),
};
// function materialiseSpec(spec: ITraceSpec, bins: Bin[]) {
//     const m = {};
//     for (const key in spec) {
//         const value: any | undefined = spec[key];
//         m[key] = spec[key](bins);
//     }
//     return m;
// }
function buildTraceData(spec, bins) {
    return {
        type: 'bar',
        // --- spec-based items
        x: spec.x(bins),
        y: spec.y(bins),
        text: spec.text(bins),
        customdata: spec.customdata(bins),
        hovertemplate: spec.hovertemplate,
        // ----
        width: (bins.length > 0 ? bins.map(b => b.size) : 1),
        textposition: 'auto',
        textangle: 0,
        marker: {
            color: 'rgb(127,199,245)',
            opacity: 0.8,
            line: {
                color: 'rgb(255,255,255)',
                width: 0.5,
            }
        },
    };
}
function buildLayoutData(bins) {
    return {
        // autosize: true,
        height: 300,
        width: 500,
        margin: {
            l: 50,
            r: 50,
            b: 50,
            t: 50,
            pad: 4
        },
        xaxis: {
            tickmode: "array",
            tickvals: bins.map(b => b.centre),
            ticktext: bins.map(b => b.centre.toFixed(2)),
        }
    };
}
export function HistogramPlot({ bins, traceSpec }) {
    return (React.createElement(Plot, { data: [
            buildTraceData(traceSpec, bins),
        ], layout: buildLayoutData(bins) }));
}
//# sourceMappingURL=HistogramPlot.js.map